import {
  Button,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Link,
  Card as MuiCard,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { colors } from "../themes/geops-ui";

const StyledCardMedia = styled(CardMedia)(() => {
  return {
    "&:hover": { boxShadow: "10px 10px 19px -13px rgba(0,0,0,0.3)" },
    backgroundColor: colors.secondaryGray,
    backgroundSize: "contain",
    border: "none",
    height: "50%",
    maxHeight: 200,
    objectFit: "contain",
    position: "relative",
  };
}) as typeof CardMedia;
const StyledCard = styled(MuiCard)(() => {
  return {
    "&:hover": { boxShadow: "10px 10px 19px -13px rgba(0,0,0,0.3)" },
    position: "relative",
  };
});

const StyledCardWithActions = styled(MuiCard)(() => {
  return { position: "relative" };
});

const StyledLink = styled(Link)({ color: "initial" });

const StyledButton = styled(Button)({
  "&:hover": { boxShadow: "none" },
  borderBottomLeftRadius: 0,
  borderTopRightRadius: 0,
  padding: "10px 25px",
});

const StyledCardActions = styled(CardActions)({
  bottom: 0,
  position: "absolute",
  right: 0,
});

const StyledCardActionArea = styled(CardActionArea)({ display: "contents" });

export interface CardProps {
  buttonText?: string;
  desc?: string;
  href?: string;
  image?: string;
  title?: string;
}

function Card({ buttonText = "more...", desc, href, image, title }: CardProps) {
  const rawCard = (
    <>
      {image && <StyledCardMedia component="img" image={image} />}
      <CardContent>
        <Typography variant="h3">{title}</Typography>
        <Typography>{desc}</Typography>
      </CardContent>
    </>
  );

  if (!href) {
    return <StyledCard>{rawCard}</StyledCard>;
  }

  return (
    <StyledCardWithActions>
      <StyledLink href={href} underline="none">
        <StyledCardActionArea>{rawCard}</StyledCardActionArea>
      </StyledLink>
      <StyledCardActions>
        <StyledButton href={href}>{buttonText}</StyledButton>
      </StyledCardActions>
    </StyledCardWithActions>
  );
}

export default Card;
